import axios from "axios";

export const createPrescriptionsAcknowledgmentRequest =
  async (): Promise<void> => {
    await axios.post(`/api/checkins/prescriptions`, { skipped: false });
  };
